/* eslint-disable max-lines */
import { ExternalLink } from '@uikit';

export const keyFeatures = [
  {
    id: 'cross-platform-gaming',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Cross-Platform Gaming:&nbsp;</span>
        {`Accessible on both mobile and desktop, Pinkmoon Studios' games ensure seamless gameplay
        across devices.`}
      </span>
    ),
  },
  {
    id: 'mythos-engine',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Mythos Engine:&nbsp;</span>A No-Code MMO-as-a-Service
        platform that cuts development time by up to 50%, helping developers bring their games to
        market faster.
      </span>
    ),
  },
  {
    id: 'player-owned',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Player-Owned Economies:&nbsp;</span>
        {`Players can stake, trade, and govern the ecosystem with $PIMS, giving them full ownership of
        in-game assets and a voice in the platform’s future.`}
      </span>
    ),
  },
];

export const participationCriteria = [
  {
    id: 'upgrade-your-magic-store-acoount',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Upgrade Your Magic Store Account: &nbsp;</span>
        Access the Magic Store at{' '}
        <ExternalLink href="https://magicsquare.io/store" className="text-base-text-blue underline">
          this link
        </ExternalLink>{' '}
        and upgrade your account for exclusive benefits. More details can be found{' '}
        <ExternalLink
          href="https://docs.magicsquare.io/for-users/magic-memberships"
          className="text-base-text-blue underline"
        >
          here
        </ExternalLink>
        .
      </span>
    ),
  },
  {
    id: 'enter-the-free-whitelist-giveaway-campaign',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Enter the Free Whitelist Giveaway Campaign:&nbsp;</span>
        Complete this quick campaign in under a few minutes for a chance to join the whitelist{' '}
        <ExternalLink
          href="https://soquest.xyz/space/MagicSquare/campaign/5Uh7pmOU4D"
          className="text-base-text-blue underline"
        >
          Join here.
        </ExternalLink>
      </span>
    ),
  },
  {
    id: 'exclusive-whitelist-via-pinkmoon-community',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Exclusive Whitelist via Pinkmoon Community:&nbsp;</span>
        Connect with the Pinkmoon team on Telegram for an exclusive whitelist opportunity.{' '}
        <ExternalLink
          href="https://t.me/kryptomonofficial"
          className="text-base-text-blue underline"
        >
          Contact here.
        </ExternalLink>
      </span>
    ),
  },
];

export const tractions = [
  {
    id: 'twitter-traction',
    item: (
      <span className="font-normal">
        <span className="font-semibold">130K&nbsp;</span>
        Twitter followers
      </span>
    ),
  },
  {
    id: 'twitter-traction',
    item: (
      <span className="font-normal">
        <span className="font-semibold">90K&nbsp;</span>
        Discord members
      </span>
    ),
  },
  {
    id: 'twitter-traction',
    item: (
      <span className="font-normal">
        <span className="font-semibold">15K&nbsp;</span>
        Telegram members
      </span>
    ),
  },
  {
    id: 'twitter-traction',
    item: (
      <span className="font-normal">
        <span className="font-semibold">10K&nbsp;</span>
        YouTube subscribers
      </span>
    ),
  },
  {
    id: 'twitter-traction',
    item: (
      <span className="font-normal">
        <span className="font-semibold">$3.5 billion&nbsp;</span>
        in trading volume in the past 4 months
      </span>
    ),
  },
  {
    id: 'twitter-traction',
    item: (
      <span className="font-normal">
        <span className="font-semibold">$150,000&nbsp;</span>
        in revenue pre-token launch
      </span>
    ),
  },
];

export const businessModel = [
  {
    id: 'game-subs-fees',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Game Subscription Fees:&nbsp;</span>
        Players pay a monthly subscription to access immersive MMO games like KMON: World of Kogaea.
      </span>
    ),
  },
  {
    id: 'marketplace-fees',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Marketplace Fees:&nbsp;</span>
        Pinkmoon takes a 5% fee on in-game transactions in its player-driven marketplace.
      </span>
    ),
  },
  {
    id: 'mythos-engine',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Mythos Engine Subscription Fees:&nbsp;</span>
        Developers using the Mythos Engine will pay ongoing subscription fees for access and
        support.
      </span>
    ),
  },
  {
    id: 'breeding-fees',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Breeding Fees:&nbsp;</span>
        Kryptomon breeding fees range from $20 to $75, generating revenue from NFT creation.
      </span>
    ),
  },
  {
    id: 'nft-sales',
    item: (
      <span className="font-normal">
        <span className="font-semibold">NFT Sales:&nbsp;</span>
        Sales of exclusive in-game assets, collectibles, and phygital items continue to be a core
        revenue stream.
      </span>
    ),
  },
];

export const investors = [
  {
    key: 'nfx',
    name: 'NFX',
    image: '/launchpad/stories/pink-moon/investors/nfx.png',
    width: 100,
    height: 100,
    className: 'text-center',
  },
  {
    key: 'griffin-gaming-partners',
    name: (
      <>
        Griffin Gaming
        <br />
        Partners
      </>
    ),
    image: '/launchpad/stories/pink-moon/investors/griffin-gaming-partners.png',
    width: 100,
    height: 100,
    className: 'text-center',
  },
  {
    key: 'playstudios',
    name: 'Playstudios Inc',
    image: '/launchpad/stories/pink-moon/investors/playstudios-inc.png',
    width: 100,
    height: 100,
    className: 'text-center',
  },
  {
    key: 'tal-ventures',
    name: 'Tal Ventures',
    image: '/launchpad/stories/pink-moon/investors/tal-ventures.png',
    width: 100,
    height: 100,
    className: 'text-center',
  },
];

export const partners = [
  {
    name: 'Sweat Economy',
    image: '/launchpad/stories/pink-moon/partners/sweat-economy.png',
    width: 165,
    height: 16,
    className: 'py-6 px-3',
  },
  {
    name: 'Polygon',
    image: '/launchpad/stories/pink-moon/partners/polygon.png',
    width: 138,
    height: 49,
    className: 'py-2.5 px-[26px]',
  },
  {
    name: 'ImmutableX',
    image: '/launchpad/stories/pink-moon/partners/immutable-x.png',
    width: 162,
    height: 38,
    className: 'py-[17px] px-[14px]',
  },
  {
    name: 'Wemix',
    image: '/launchpad/stories/pink-moon/partners/wemix.png',
    width: 150,
    height: 44,
    className: 'py-[14px] px-5',
  },
  {
    name: 'ChainLink',
    image: '/launchpad/stories/pink-moon/partners/chain-link.png',
    width: 156,
    height: 52,
    className: 'py-[10px] px-[17px]',
  },
  {
    name: 'Covey',
    image: '/launchpad/stories/pink-moon/partners/covey.png',
    width: 137,
    height: 43,
    className: 'py-2.5 px-[17px]',
  },
  {
    name: 'ChainGPT',
    image: '/launchpad/stories/pink-moon/partners/chain-gpt.png',
    width: 167,
    height: 43,
    className: 'py-[15px] px-3',
  },
  {
    name: 'Unstoppable Domain',
    image: '/launchpad/stories/pink-moon/partners/unstoppable-domains.png',
    width: 172,
    height: 46,
    className: 'py-[13px] px-[9px]',
  },
];

export const tokenUtility = [
  {
    id: 'staking',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Staking:&nbsp;</span>
        Players can stake $PIMS to earn ongoing rewards from Pinkmoon Studio’s revenue streams.
      </span>
    ),
  },
  {
    id: 'governance',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Governance:&nbsp;</span>
        $PIMS holders can vote on platform developments, including $PIMS Grants, ensuring
        community-driven decisions.
      </span>
    ),
  },
  {
    id: 'revenue-sharing',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Revenue Sharing:&nbsp;</span>A portion of Pinkmoon&apos;s profits
        will be shared with $PIMS stakers, aligning the success of the platform with token holders.
      </span>
    ),
  },
  {
    id: 'supernets',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Supernets:&nbsp;</span>
        $PIMS will serve as the validator and gas token for Pinkmoon’s upcoming blockchain on
        Polygon Supernets.
      </span>
    ),
  },
  {
    id: 'mythos-engine-features',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Mythos Engine Features:&nbsp;</span>
        Third-party developers will need $PIMS tokens to unlock advanced features on the Mythos
        Engine, ensuring deeper utility within the broader developer ecosystem.
      </span>
    ),
  },
  {
    id: 'price-growth-drivers',
    item: (
      <span className="font-normal">
        <span className="font-semibold">Price Growth Drivers:&nbsp;</span>
        Increased game adoption, higher staking demand, and broader Mythos Engine commercialization
        are expected to drive demand for $PIMS, positively impacting its market price.
      </span>
    ),
  },
];

export const marketTraction = [
  {
    id: 'growth',
    content: 'Community Growth:',
    item: [
      { id: 'players', subItem: <span className="font-normal">Over 200,000 players</span> },
      { id: 'followers', subItem: <span className="font-normal">150,000 Twitter followers</span> },
      { id: 'members', subItem: <span className="font-normal">65,000 Discord members</span> },
    ],
  },
  {
    id: 'play-test-result',
    content: 'Playtest Results (KMON: World of Kogaea):',
    item: [
      {
        id: '21',
        subItem: (
          <span className="font-normal">
            <span className="font-semibold">10,000 players</span> joined the most recent playtest
            over a two-week period.
          </span>
        ),
      },
      {
        id: '22',
        subItem: (
          <span className="font-normal">
            <span className="font-semibold">60% Day-1 Retention, 31% Day-7 Retention,</span> and{' '}
            <span className="font-semibold">17% Day-14 Retention</span> for overall users.
          </span>
        ),
      },
    ],
  },
  {
    id: 'revenue',
    content: 'Revenue from NFT Sales:',
    item: [
      {
        id: '31',
        subItem: (
          <span className="font-normal">
            All three NFT sales on Binance NFT sold out in under a minute, including Kryptomon eggs
            and a phygital clothing line.
          </span>
        ),
      },
      {
        id: '32',
        subItem: (
          <span className="font-normal">
            Conducted the first-ever NFT gaming drop on Crypto.com, also sold out in under a minute.
          </span>
        ),
      },
    ],
  },
  {
    id: 'presense',
    content: 'Strong Presence on CEXs:',
    item: [
      {
        id: '40',
        subItem: (
          <span className="font-normal">
            KMON token is traded on major exchanges such as Bybit, MEXC, and Gate.io.
          </span>
        ),
      },
    ],
  },
  {
    id: 'partnerships-collaborations',
    content: 'Partnerships and Collaborations:',
    item: [
      {
        id: '44',
        subItem: (
          <span className="font-normal">
            Collaborations with Sweat Economy, ChainGPT, Polygon, Unstoppable Domains, and more.
          </span>
        ),
      },
    ],
  },
  {
    id: 'physical-launch',
    content: 'Physical Launch:',
    item: [
      {
        id: '54',
        subItem: (
          <span className="font-normal">
            Launched a phygital trading card game available in over 3,000 physical stores in Italy.
          </span>
        ),
      },
    ],
  },
];

export const teamMembers = [
  {
    id: 'umberto',
    fullName: 'Umberto Canessa',
    about: (
      <p className="font-normal">
        A serial entrepreneur with over 13 years in crypto, Umberto has worked with major brands
        like Nestlé, Heineken, Coca-Cola, and Philips.
        <br />
        <ExternalLink
          className="text-primary-600 underline"
          href="https://www.linkedin.com/in/umbertocanessa/"
        >
          LinkedIn
        </ExternalLink>
      </p>
    ),
    width: 104,
    height: 104,
    position: 'CEO',
    avatar: '/launchpad/stories/pink-moon/team/umberto.png',
  },
  {
    id: 'brian-bento',
    fullName: 'Brian Bento',
    about: (
      <p className="font-normal">
        Former Senior Director of Engineering at Oracle and ex-designer for World of Warcraft.
        <br />
        <ExternalLink
          className="text-primary-600 underline"
          href="https://www.linkedin.com/in/brianmbento/"
        >
          LinkedIn
        </ExternalLink>
      </p>
    ),
    width: 104,
    height: 104,
    position: 'CPO',
    avatar: '/launchpad/stories/pink-moon/team/brian.png',
  },
  {
    id: 'bartolomeo-de-vitis',
    fullName: 'Bartolomeo De Vitis',
    about: (
      <p className="font-normal">
        An experienced finance leader and former Innovation Manager at ABN Amro.
        <br />
        <ExternalLink
          className="text-primary-600 underline"
          href="https://www.linkedin.com/in/bartolomeodevitis/"
        >
          LinkedIn
        </ExternalLink>
      </p>
    ),
    width: 104,
    height: 104,
    position: 'CFO',
    avatar: '/launchpad/stories/pink-moon/team/bartolomeo.png',
  },
];
